import { RedirectPage } from "components/UI/RedirectPage/RedirectPage.tsx";
import { Route as FormDesignPage } from "routes/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/form";
import { Route as FunnelDesignPage } from "routes/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/funnel";
import { Route as ScreenDesignPage } from "routes/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/screen";
import { PermissionEnum } from "types/enums.ts";
import { createTenantFileRoute, RouteStaticData } from "utils/createTenantFileRoute.ts";

const staticData: RouteStaticData = {
    permissions: [PermissionEnum.ToolDesignFunnel, PermissionEnum.ToolDesignForm, PermissionEnum.ToolDesignScreen],
    showInSideMenu: true,
    sideMenuParent: "lazy", // Is defined below after parent route is initialized
    label: "pages.tool.design.title",
    sort: 4,
    redirects: [FormDesignPage, FunnelDesignPage, ScreenDesignPage],
    defaultRedirect: FormDesignPage,
};

export const Route = createTenantFileRoute("/_authenticated/$tenantSlug/_layout/tool/_layout/design/")({
    component: ToolDesignPage,
    staticData,
    loader: ({ context: { t } }) => ({
        breadcrumb: t("pages.tool.design.title"),
    }),
});

function ToolDesignPage() {
    return <RedirectPage />;
}

// Delay sideMenuParent after parent route is initialized
import("routes/_authenticated/$tenantSlug/_layout/tool/index.tsx").then((mod) => {
    staticData.sideMenuParent = mod.Route;
});
